import { render } from "./Certificati.vue?vue&type=template&id=3ee9a3ce"
import script from "./Certificati.vue?vue&type=script&lang=js"
export * from "./Certificati.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__